// 游客用户管理工具

const GUEST_USER_KEY = 'guestUser';
const GUEST_REPORTS_KEY = 'guestReports';

// 生成游客用户ID
const generateGuestId = () => {
  return `guest_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

// 创建游客用户
export const createGuestUser = () => {
  const guestUser = {
    id: generateGuestId(),
    name: '游客',
    phone: '',
    isGuest: true,
    createdAt: new Date().toISOString()
  };
  
  localStorage.setItem(GUEST_USER_KEY, JSON.stringify(guestUser));
  return guestUser;
};

// 获取游客用户
export const getGuestUser = () => {
  const guestUserStr = localStorage.getItem(GUEST_USER_KEY);
  if (guestUserStr) {
    return JSON.parse(guestUserStr);
  }
  return null;
};

// 检查是否为游客
export const isGuestUser = (user) => {
  return user && user.isGuest === true;
};

// 保存游客报告到本地
export const saveGuestReport = (report) => {
  const reportsStr = localStorage.getItem(GUEST_REPORTS_KEY);
  let reports = reportsStr ? JSON.parse(reportsStr) : [];
  
  // 添加新报告
  reports.unshift(report);
  
  // 最多保存10条报告
  if (reports.length > 10) {
    reports = reports.slice(0, 10);
  }
  
  localStorage.setItem(GUEST_REPORTS_KEY, JSON.stringify(reports));
  return report;
};

// 获取游客报告列表
export const getGuestReports = () => {
  const reportsStr = localStorage.getItem(GUEST_REPORTS_KEY);
  return reportsStr ? JSON.parse(reportsStr) : [];
};

// 获取单个游客报告
export const getGuestReport = (reportId) => {
  const reports = getGuestReports();
  return reports.find(r => r.id === reportId);
};

// 清除游客数据
export const clearGuestData = () => {
  localStorage.removeItem(GUEST_USER_KEY);
  localStorage.removeItem(GUEST_REPORTS_KEY);
};

// 将游客数据转换为正式用户数据（用于后续升级）
export const getGuestDataForUpgrade = () => {
  return {
    reports: getGuestReports(),
    createdAt: getGuestUser()?.createdAt
  };
};

